import cardApi from '../api/cardApi'
export default {
    getIOSCardHome(params){
        return cardApi.getIOSCardHome(params)
    }
}